import { FC, Fragment } from 'react';
import { TFunction } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import LandingPageListingCardMinimal from 'src/common/components/LandingPageListingCardMinimal';
import styles from './LandingPageTopListings.module.scss';

type LandingPageTopListing = {
  listingUrl: string;
  headline: string;
  location: string;
  photoUrl: string;
  rating: string;
};

type LandingPageTopListingsProps = {
  subtitle: string;
  title: string;
  topListings: LandingPageTopListing[];
  translationFunction: TFunction;
};

const LandingPageTopListings: FC<LandingPageTopListingsProps> = ({
  subtitle,
  title,
  topListings,
  translationFunction,
}) => (
  <PitchPageLayout backgroundColor="midnight01">
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Typography
            type="h2"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {title}
          </Typography>
        </div>
        <div className={styles.subtitle}>
          <Typography type="p" size="body-xl">
            {subtitle}
          </Typography>
        </div>
      </div>
      <CarouselProvider>
        <Carousel>
          {topListings?.map((listing) => (
            <Fragment key={listing.listingUrl}>
              <LandingPageListingCardMinimal
                {...listing}
                translationFunction={translationFunction}
              />
            </Fragment>
          ))}
        </Carousel>
        <CarouselButtons
          spacing="together"
          variant="primary-blue"
        />
      </CarouselProvider>
    </div>
  </PitchPageLayout>
);

export default LandingPageTopListings;
